import { Controller } from "@hotwired/stimulus"
import Choices from "choices.js"

export default class extends Controller {
  static targets = ["form", "projectSelect", "workerSelect", "monthField"]

  connect() {
    if (this.hasProjectSelectTarget) {
      this.projectChoices = new Choices(this.projectSelectTarget, {
        shouldSort: false,
        itemSelectText: '',
        noResultsText: '見つかりません'
      })
    }

    if (this.hasWorkerSelectTarget) {
      this.workerChoices = new Choices(this.workerSelectTarget, {
        shouldSort: false,
        itemSelectText: '',
        noResultsText: '見つかりません'
      })
    }
  }

  disconnect() {
    if (this.projectChoices) {
      this.projectChoices.destroy()
      this.projectChoices = null
    }
    
    if (this.workerChoices) {
      this.workerChoices.destroy()
      this.workerChoices = null
    }
  }

  preventEnter(event) {
    if (event.key === "Enter") {
      event.preventDefault()
    }
  }

  submitForm() {
    if (this.hasFormTarget) this.formTarget.requestSubmit()
  }
}